import {Directive, ElementRef, Renderer2, HostListener, OnInit, Input} from '@angular/core';

@Directive({
  standalone: true,
  selector: '[appHideOnMobile]'
})
export class HideOnMobileDirective implements OnInit {

  constructor(private el: ElementRef, private renderer: Renderer2) {}

  @Input() active = true;
  @Input() breakpoint = 992;

  ngOnInit() {
    this.toggleVisibility();
  }

  @HostListener('window:resize')
  onResize() {
    this.toggleVisibility();
  }

  private toggleVisibility() {
    if (window.innerWidth < this.breakpoint && this.active) {
      this.renderer.setStyle(this.el.nativeElement, 'display', 'none');
    } else {
      this.renderer.removeStyle(this.el.nativeElement, 'display');
    }
  }
}

@Directive({
  standalone: true,
  selector: '[appShowOnMobile]'
})
export class ShowOnMobileDirective implements OnInit {

  constructor(private el: ElementRef, private renderer: Renderer2) {}

  @Input() active = true;
  @Input() breakpoint = 992;
  ngOnInit() {
    this.toggleVisibility();
  }

  @HostListener('window:resize')
  onResize() {
    this.toggleVisibility();
  }

  private toggleVisibility() {
    if (window.innerWidth < this.breakpoint && this.active) {
      this.renderer.removeStyle(this.el.nativeElement, 'display');
    } else {
      this.renderer.setStyle(this.el.nativeElement, 'display', 'none');
    }
  }
}
